Object.defineProperty(exports, "__esModule", { value: true });
var browsertracing_1 = require("./browsertracing");
exports.BrowserTracing = browsertracing_1.BrowserTracing;
var request_1 = require("./request");
exports.registerRequestInstrumentation = request_1.registerRequestInstrumentation;
exports.defaultRequestInstrumentationOptions = request_1.defaultRequestInstrumentationOptions;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/tracing/dist/browser/index.js
// module id = 64
// module chunks = 0